import React, { useState } from 'react';
import { Typography, Popover, Paper } from '@mui/material';

const MouseoverPopup: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMouseLeave = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'hiring-guarantee-popover' : undefined;

  return (
    <>
      <Typography
        aria-describedby={id}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{
          cursor: 'pointer',
          fontWeight: 600,
          color: 'rgba(255,255,255,0.85)',
          '&:hover': { color: 'white', textDecoration: 'underline' },
          textAlign: 'center',
        }}
      >
        *Our Hiring Guarantee
      </Typography>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleMouseLeave}
        disableRestoreFocus
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        sx={{
          pointerEvents: 'none', // Prevents scrollbar issues
        }}
        PaperProps={{
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
          sx: {
            pointerEvents: 'auto', // Re-enable pointer events for the Paper
            maxWidth: 610, // Increased from 400 to 500
            p: 2,
            borderTop: '5px solid red',
            borderRadius: 2,
            backgroundColor: '#fff',
            zIndex: 1300,
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            overflow: 'hidden', // Prevent internal scrolling
          },
        }}
        disableScrollLock={true} // Prevent MUI from modifying the body styles
      >
        <Paper elevation={0}>
          <Typography variant="h6" color="error" sx={{ mb: 1 }}>
            Our Hiring Guarantee
          </Typography>
          <Typography variant="body2" color="text.secondary">
            If you don't make a hire using our Recruitment Intelligence® platform, we'll credit you <strong>$500</strong> toward a fully managed search led by our <strong>Forbes-ranked team</strong>. With a <strong>93.8%</strong> hire rate and <strong>10+ years</strong> of success, you only have exceptional talent to gain.
          </Typography>
        </Paper>
      </Popover>
    </>
  );
};

export default MouseoverPopup;
